import { render, staticRenderFns } from "./alerting-settings.vue?vue&type=template&id=4a01eac4&"
import script from "./alerting-settings.vue?vue&type=script&lang=js&"
export * from "./alerting-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports